const DIA = () => import('../views/Diarias.vue')
const FOLH = () => import('../views/Folha.vue')
const TDA = () => import('../views/tabelaDiarias.vue')
const COV = () => import('../views/Convenios.vue')
const CEIS = () => import('../views/Sancionados.vue')

export default [
  { name: 'viewDiar', path: '/transparencia/diarias', component: DIA },
  { name: 'viewFol', path: '/transparencia/folha-de-pagamento', component: FOLH },
  { name: 'viewTda', path: '/transparencia/tabela-das-diarias', component: TDA, meta: { acl: true } },
  { name: 'viewConvenio', path: '/transparencia/convenios', component: COV, meta: { acl: true } },
  { name: 'viewSancionado', path: '/transparencia/sancionados', component: CEIS, meta: { acl: true } }
]
